export default "__VITE_ASSET__BGxJqj9O__"